import React from "react";

export function AmpelWidget(props) {
  const { data, ui } = props;
  const widgetId = ui.id;

  let content = data && data.content ? data.content : "";
  let { firstDotColor, secondDotColor, thirdDotColor} = defineDotColors(content);

  return (
    <div id={widgetId} style={rootStyle}>
      <span style={{...dotStyle, backgroundColor: firstDotColor}}></span>
      <span style={{...dotStyle, backgroundColor: secondDotColor}}></span>
      <span style={{...dotStyle, backgroundColor: thirdDotColor}}></span>
    </div>
  );
}

const rootStyle = {
  display: "flex",
  padding: "2px",
  marginTop: "2px",
};

const dotStyle = {
  height: "22px",
  width: "22px",
  borderRadius: "50%",
  display: "inline-block",
  border: "1px solid",
  boxShadow: "inset -4px -5px 6px 3px rgba(0,0,0,0.2), 0px 0px 2px 0px black",
};

const defineDotColors = (content) => {
  let first = "grey";
  let second = "grey";
  let third = "grey";

  switch (content) {
    case "0":
      first = "red";
      break;
    case "1":
      second = "orange";
      break;
    case "2":
      third = "green";
      break;
    default:
      break;
  }

  return {firstDotColor: first, secondDotColor: second, thirdDotColor: third};
};
